// src/legal/legalConfig.ts
// Az ÁSZF és az Adatvédelmi nyilatkozat közös adatai. Itt egy helyen módosíthatók.

export const LEGAL = {
  brandName: "Csillagtanoda",
  website: "csillagtanoda.hu",

  // Szolgáltató / adatkezelő adatai
  companyName: "Sándor Csilla Judit egyéni vállalkozó",
  address: "4600 Kisvárda, Labanc út 9.",
  taxNumber: "63214370-1-35",
  registrationNumber: "5350051",
  email: "csillagtanoda.info@gmail.com",
  phone: "+36 30 447 4333", // TODO: töltsd ki

  // Tárhelyszolgáltató (megjelenik az ÁSZF 1. pontjában és az Adatvédelmi nyilatkozat adatfeldolgozói között)
  hostingProvider: "Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen, Németország (info@hetzner.com)",

  // Fogyasztói jogvita esetén illetékes békéltető testület (Szabolcs-Szatmár-Bereg vármegye ügyeiben)
  conciliationBody:
    "Hajdú-Bihar Vármegyei Békéltető Testület (4025 Debrecen, Petőfi tér 10., e-mail: bekelteto@hbkik.hu)",

  // Hatályba lépés dátuma
  effectiveDate: "2026. 10. 09.",
};